export enum ColorTokensEnum {
  // --- PRIMARY ---
  DECORATIVE = "decorative",
  DECORATIVE_BG = "decorative-bg",
  INTERACTIVE = "interactive",
  BRAND_DARK = "brand-dark",
  ACCENT = "accent",

  // --- GREYSCALE ---
  WHITE = "white",
  LIGHTEST_GREY = "lightest-grey",
  BLUE_GREY = "blue-grey",
  LIGHT_GREY = "light-grey",
  MED_GREY = "med-grey",
  DARK_GREY = "dark-grey",
  TOOLTIP_FILL = "tooltip-fill",
  DARKEST_GREY = "darkest-grey",

  // --- STATES ---
  SUCCESS = "success",
  INFO = "info",
  WARNING = "warning",
  ERROR = "error",
  HOVER = "hover",
  HOVER_LIGHT = "hover-light",
  DISABLED = "disabled",

  // --- SECONDARY ---
  DARK_LANSING_BLUE = "dark-lansing-blue",
  MID_BLUE = "mid-blue",
  GREEN = "green",
  MID_GREEN = "mid-green",
  DARK_MID_GREEN = "dark-mid-green",
  ORANGE = "orange",
  DARK_ORANGE = "dark-orange",
  GOLD = "gold",
}
